import * as React from 'react';
var BackgroundContext = /*#__PURE__*/React.createContext(null);

/**
 * This component can be used to tell descedant Typography components what color
 * the background is.  The Typography components will pick a color that
 * contrasts well with the background.  For example, if you specifiy the
 * background is "primary", all descedant Typography components will be white
 *
 * @param props
 */
export function BackgroundProvider(props) {
  return /*#__PURE__*/React.createElement(BackgroundContext.Provider, {
    value: props.color
  }, props.children);
}
export var useBackground = function useBackground() {
  return React.useContext(BackgroundContext);
};